import React from "react";
import { SectionTag } from "./ui/SectionTag";
import { TESTIMONIALS } from "../constants";
import { motion } from "framer-motion";


interface TestimonialCardProps {
  testimonial: any;
  index: number;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  testimonial,
  index,
}) => (
  <div 
    className="min-h-[15rem] w-[25rem] bg-white p-10 rounded-[20px] flex flex-col flex-shrink-0 relative group hover:shadow-sm transition-shadow duration-300"
  >
     {/* Product Type */}
     {testimonial.productType && (
       <div className="mb-3">
         <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
           {testimonial.productType}
         </p>
       </div>
     )}

     {/* Quote */}
    <p className="text-body font-medium text-gray-500 mb-4 flex-1">
        {testimonial.quote}
     </p>

     {/* Bottom Area */}
     <div className="mt-auto">
        <div className="flex items-center gap-4 mb-3">
             <img 
                src={testimonial.avatar} 
                alt={testimonial.name} 
                className="w-12 h-12 rounded-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all"
             />
             <div>
          <h5 className="text-body font-bold text-gray-900">
            {testimonial.name}
          </h5>
          <p className="text-body text-gray-400">{testimonial.role}</p>
             </div>
        </div>

        {/* Project Use */}
        {testimonial.projectUse && (
          <div className="mt-3 pt-3 border-t border-gray-100">
            <p className="text-[10px] text-gray-500 uppercase tracking-wider">
              <span className="font-bold">Project Use:</span> {testimonial.projectUse}
            </p>
          </div>
        )}
     </div>
  </div>
);

export const TestimonialsSection: React.FC = () => {
  return (
    <section className="bg-[#F9F9F9] overflow-hidden py-16 lg:py-24">
      <div className="w-[90%] lg:w-[70%] mx-auto px-2 lg:px-12 mb-20 text-center">
          <div className="flex justify-center">
          <SectionTag>TESTIMONIAL</SectionTag>
          </div>
        <h2 className="text-heading-section font-normal text-gray-900 mb-2 font-neue-haas">
          Specified by Architects
        </h2>
        <p
          className="text-heading-large font-normal bg-gradient-to-r
         from-[#e20016] from-[0%]
         via-[#712f59] via-[40%]
         to-[#005d9c] to-[100%] bg-clip-text text-transparent font-neue-haas mb-2"
        >
          Trusted by Dealers.
        </p>
        <p className="text-gray-500 text-body max-w-2xl mx-auto">
          Leading architects share their experiences with Croma Ply products,
          highlighting reliability, performance, and quality across diverse project types.
          </p>
      </div>

      <div className="w-[90%] lg:w-[70%] mx-auto flex flex-col gap-8">
        {/* Row 1: Right to Left */}
        <div className="w-full overflow-hidden">
             <motion.div 
                className="flex gap-6 pl-6"
                initial={{ x: 0 }}
                animate={{ x: "-50%" }}
                transition={{
                    repeat: Infinity,
                    ease: "linear",
                    duration: 280,
                }}
                style={{ width: "max-content" }}
             >
                {/* Looping content multiple times to ensure smooth infinite scroll */}
            {[
              ...TESTIMONIALS,
              ...TESTIMONIALS,
              ...TESTIMONIALS,
              ...TESTIMONIALS,
            ].map((t, i) => (
                    <TestimonialCard key={`r1-${i}`} testimonial={t} index={i} />
                ))}
             </motion.div>
        </div>

        {/* Row 2: Left to Right */}
        {/* <div className="w-full overflow-hidden">
             <motion.div 
                className="flex gap-6 pl-6"
                initial={{ x: "-50%" }}
                animate={{ x: "0%" }}
                transition={{
                    repeat: Infinity,
                    ease: "linear",
                    duration: 280,
                }}
                style={{ width: "max-content" }}
             >
            {[
              ...TESTIMONIALS,
              ...TESTIMONIALS,
              ...TESTIMONIALS,
              ...TESTIMONIALS,
            ].map((t, i) => (
                    <TestimonialCard key={`r2-${i}`} testimonial={t} index={i + 1} />
                ))}
             </motion.div>
        </div> */}
      </div>
    </section>
  );
};
